'use client';
import * as React from 'react';
import type { Transition, Variants } from 'framer-motion';
import { motion, useAnimation } from 'framer-motion';

const keyVariants: Variants = {
	normal: {
		rotate: 0,
		scale: 1,
	},
	animate: {
		rotate: [0, 15, -15, 0],
		scale: [1, 1.05, 1, 1],
	},
};

const svgTransition: Transition = {
	duration: 0.6,
	ease: 'easeInOut',
};

interface IconProps {
	isHovered: boolean;
}

export function KeyIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<motion.svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				variants={keyVariants}
				animate={controls}
				transition={svgTransition}
			>
				<path d='M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z' />
				<path d='m14 7 3 3' />
				<path d='m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814' />
			</motion.svg>
		</div>
	);
}